/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import TooltipBase, { TooltipProps } from '@material-ui/core/Tooltip';

import { tooltipInvertedStyles, tooltipStyles } from './style';

export type { TooltipProps } from '@material-ui/core/Tooltip';

interface TooltipPropsExtended extends TooltipProps {
  actionText?: string;
  isDisabled?: boolean;
}

const TooltipComponent = withStyles(tooltipStyles)(TooltipBase);
const TooltipBaseInverted = withStyles(tooltipInvertedStyles)(TooltipBase);
// Tooltip children as to accept a ref, hence React.forwardRef https://v4.mui.com/guides/composition/#caveat-with-refs
const Tooltip = React.forwardRef(
  (props: Partial<TooltipPropsExtended>, ref: React.Ref<any>) => {
    const { children, title, interactive, placement, isDisabled } = props;

    let TooltipComponentRef = TooltipComponent;

    // Always invert background color if interactive prop set to `true`
    if (interactive) {
      TooltipComponentRef = TooltipBaseInverted;
    }

    if (isDisabled) return <div>{children}</div>;

    return (
      <>
        {children && (
          <TooltipComponentRef
            title={<>{title}</>}
            placement={placement}
            // Props spreading rule doesn't make sense in TS context, Hence disabling it here
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
          >
            <div ref={ref}>{children}</div>
          </TooltipComponentRef>
        )}
      </>
    );
  }
);

export { Tooltip as TooltipIcon };
export default Tooltip;
